<app-card icon="map" title="Best Seller Routes" iconGradient="from-orange-500 to-red-500" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button [data]="exportData()" [excelTitle]="'best-seller-route'" [columns]="cols"></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="bestSellerRouteData() || []"
        [loading]="loading()"
        [oddRowColor]="'#dff1eb'"
    ></app-table-component>
    <!-- Templates -->
    <ng-template #depPortTemplate let-rowData="rowData">
        <span>{{ rowData.route.depPort }}</span>
    </ng-template>

    <ng-template #arrPortTemplate let-rowData="rowData">
        <span>{{ rowData.route.arrPort }}</span>
    </ng-template>
</app-card>
